import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Modal } from 'components/layout/modal/Modal';
import { Portal } from 'components/other/portal/Portal';
import { Transition } from 'components/other/transition/Transition';
import { closeCallback, selectCallback } from './callback.slice';
import { CallbackBody } from './callbackBody/CallbackBody';

export const Callback = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const callback = useAppSelector(selectCallback);

  return (
    <Transition active={callback.ui.callbackOpened} timeout={300}>
      {(transitionStyles) => (
        <Portal blocked>
          <Modal
            className={transitionStyles}
            onOverlayClick={() => dispatch(closeCallback())}
          >
            <CallbackBody />
          </Modal>
        </Portal>
      )}
    </Transition>
  );
};
